import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { dealersFilterFields } from "./fields";

const DealersFilter = () => {
  const { t } = useTranslation();

  const fields = useMemo(() => dealersFilterFields(t), [t]);

  // Дефолтов для подстановки в URL нет: в старом фильтре все значения
  // по умолчанию (filterInitDealers) были пустыми плейсхолдерами и не
  // попадали в query-переменные. Сброс — стандартный (очищает ключи
  // фильтра и page), что соответствует старому resetFilter.
  return <Filter.Root fields={fields} alwaysShow columns={5} />;
};

export default DealersFilter;
